const OPEN_CLASS = 'is-open';

export default function LangSwitcher() {
    const roots = Array.from(document.querySelectorAll('[data-lang-switcher]'));

    if (!roots.length) {
        return;
    }

    roots.forEach((root) => {
        const trigger = root.querySelector('[data-lang-trigger]');
        const menu = root.querySelector('[data-lang-menu]');

        if (!trigger || !menu) {
            return;
        }

        let open = false;

        const close = ({ focusTrigger = false } = {}) => {
            if (!open) {
                return;
            }

            open = false;
            menu.classList.remove(OPEN_CLASS);
            trigger.setAttribute('aria-expanded', 'false');

            const hide = () => {
                if (!open) {
                    menu.hidden = true;
                }
            };

            menu.addEventListener('transitionend', hide, { once: true });
            setTimeout(hide, 250);

            if (focusTrigger) {
                trigger.focus();
            }
        };

        const show = () => {
            open = true;
            menu.hidden = false;
            trigger.setAttribute('aria-expanded', 'true');

            requestAnimationFrame(() => menu.classList.add(OPEN_CLASS));
        };

        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            open ? close() : show();
        });

        document.addEventListener('click', (e) => {
            if (open && !root.contains(e.target)) {
                close();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && open) {
                close({ focusTrigger: true });
            }
        });

        root.addEventListener('focusout', () => {

            setTimeout(() => {
                if (open && !root.contains(document.activeElement)) {
                    close();
                }
            }, 0);
        });
    });
}
